import type { FirmwareTrack } from '@bhops/shared';
import { apiClient } from './client';

// Plan §D-4 — typed client for the firmware-event endpoints nested
// under /robots/:robotId/firmware-events.

export interface FirmwareEventDto {
  id: string;
  robotId: string;
  track: FirmwareTrack;
  version: string;
  appliedAt: string;
  note: string | null;
  appliedById: string | null;
  appliedBy?: { id: string; displayName: string; email?: string } | null;
  createdAt: string;
  updatedAt: string;
}

/** Server returns one row per track (latest may be null when no
 *  events have been recorded yet on that track). */
export interface LatestFirmwareEventEntry {
  track: FirmwareTrack;
  latest: FirmwareEventDto | null;
}

export interface CreateFirmwareEventBody {
  track: FirmwareTrack;
  version: string;
  appliedAt: string; // ISO date string
  note?: string;
}

export const firmwareEventsApi = {
  async listForRobot(robotId: string, track?: FirmwareTrack): Promise<FirmwareEventDto[]> {
    const { data } = await apiClient.get<FirmwareEventDto[]>(`/robots/${robotId}/firmware-events`, {
      params: track ? { track } : undefined,
    });
    return data;
  },
  async latestForRobot(robotId: string): Promise<LatestFirmwareEventEntry[]> {
    const { data } = await apiClient.get<LatestFirmwareEventEntry[]>(
      `/robots/${robotId}/firmware-events/latest`,
    );
    return data;
  },
  async create(robotId: string, body: CreateFirmwareEventBody): Promise<FirmwareEventDto> {
    const { data } = await apiClient.post<FirmwareEventDto>(
      `/robots/${robotId}/firmware-events`,
      body,
    );
    return data;
  },
};
